export default __webpack_public_path__ + "static/media/smedetoften-tenancy-13.8728c6f2.jpg";